
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class WorkOrderItemsDialog extends _Ext.MFGTransItemEditorDialog<WorkOrderItemsRow> {
        protected getFormKey() { return WorkOrderItemsForm.formKey; }
        //protected getIdProperty() { return WorkOrderItemsRow.idProperty; }
        protected getLocalTextPrefix() { return WorkOrderItemsRow.localTextPrefix; }
        //protected getNameProperty() { return WorkOrderItemsRow.nameProperty; }
        //protected getService() { return WorkOrderItemsService.baseUrl; }
        protected getDeletePermission() { return WorkOrderItemsRow.deletePermission; }
        protected getInsertPermission() { return WorkOrderItemsRow.insertPermission; }
        protected getUpdatePermission() { return WorkOrderItemsRow.updatePermission; }

        protected form = new WorkOrderItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        // #region Public Variables 

        // #endregion 

        // #region Constructor
        constructor() {
            super(); 

            // #region UI
            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName); 
            // **** Assign Values to BOM and Labor Editor ****
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight); 
            q.setTextRightAlign(this.form.NetWeight); 
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight); 
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces); 
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight); 


            // #endregion

            // #region Field Change Events

         
            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
                this.Setfields(); 
 
            });

            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value != "") {
                    this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                    this.entity.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.updateItems();
                    this.form.SubCategoryId.value = "";
                    this.Setfields();
                }
            });

           
             

            this.form.SubCategoryId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.SubCategoryId.value))
                    this.Setfields();
            });
             
            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.KaratId.value)) {

                    var KaratId = Q.toId(this.form.KaratId.value);
                    var purity: OMS.AttributeMasterRow;
                    OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                        purity = response.Entity
                    }, { async: false });
                    min = purity.MinPurity;
                    max = purity.MaxPurity;
                    std = purity.StdPurity;
                    q.showAndSetRequiredField(this.form.Purity);
                    this.form.Purity.value = std;
                }

            });

            this.form.MetalId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.MetalId.value)) {
                    q.showAndSetRequiredField(this.form.KaratId);
                    this.form.KaratId.cascadeField = "Num1";
                    this.form.KaratId.cascadeValue = this.form.MetalId.value;
                }
            })

            this.form.Purity.change(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                min = purity.MinPurity;
                max = purity.MaxPurity;
                std = purity.StdPurity;
                if (this.form.Purity.value != null) {
                    var current = this.form.Purity.value;
                    if (current < min || current > max) {
                        Q.alert("Enter Purity between  " + min + "  to  " + max);
                        this.form.Purity.value = this.form.Purity.value;
                    } 
                }
            }); 
            this.form.SieveId.changeSelect2(e => {
                var SieveId = Q.toId(this.form.SieveId.value);
                var sievegroupid = OMS.AttributeMasterRow.getLookup().itemById[SieveId].GroupSieveId;
                this.form.GroupSieveId.value = sievegroupid.toString(); 
            });
             

            // #endregion 
        } 
        // #endregion

        // #region Open Dialog, Close Dialog etc
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.entity.RefTransId != undefined&&this.entity.RefTransId != 0) {
                q.alert('', 'Cannot Edit Items from Order', true, 2999);
                this.dialogClose();
                return;
            }
        }
        // **** Load Entity event to set fields values ****
        protected afterLoadEntity() {
            super.afterLoadEntity(); 
            if (this.form.ProductTypeId.value == "") {
                this.form.ProductTypeId.items = this.form.ProductTypeId.items.filter(x => x.id != "5" && x.id != "6" && x.id != "7");
            }
            this.Setfields();

        }  


        // #endregion
         

        // **** Method to set fields as per Item Type Called from various Events ****
        private Setfields() { 
            let useMF = q.ToBool(TabAurous.GetConfigValue(1022)); 
             

            // **** Hide Jewellery Fields **** //
            if (this.entity.ItemTypeId != 101) { 
                q.hideField(this.form.BOMDetails);
                q.hideField(this.form.BrandId);
                q.hideField(this.form.CollectionId);
                q.hideField(this.form.SuperTypeId);
                q.hideField(this.form.ProductSizeId); 
                q.hideField(this.form.NetWeight);
                q.hideField(this.form.DiamondPieces);
                q.hideField(this.form.DiamondWeight);
                q.hideField(this.form.StonePieces);
                q.hideField(this.form.StoneWeight);
                q.hideField(this.form.OtherWeight);
                q.hideField(this.form.OtherPieces); 
                q.hideField(this.form.Line_No); 
                q.hideField(this.form.HasBom);
                q.hideEditorTab(this.form.BOMDetails);
                q.hideEditorTab(this.form.ImageName);
                this.form.HasBom.value == false;

                // **** Metal Fields **** //
                if (this.form.ProductTypeId.value == "5" || this.form.ProductTypeId.value == "6" || this.form.ProductTypeId.value == "7") {
                    q.showAndSetRequiredField(this.form.KaratId);
                    q.showAndSetRequiredField(this.form.MetalColorId);
                    q.showAndSetRequiredField(this.form.Purity);
                    q.showAndDisableField(this.form.PureWeight);
                    this.form.CalcOnId.value = "4";
                    this.form.CalcUnitId.value = "7"

                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.Pieces);
                    q.hideField(this.form.SubCategoryId);
                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.Pieces);
                    q.hideField(this.form.SubCategoryId);
                    q.hideField(this.form.StoneCutId);
                    q.hideField(this.form.StonePolishId);
                    q.hideField(this.form.StoneSymmetryId);
                    q.hideField(this.form.StoneFluorescenceId);
                    q.hideField(this.form.StoneCuletId);
                    q.hideField(this.form.StoneGirdleId);
                    q.hideField(this.form.StoneTable);
                    q.hideField(this.form.StoneDepth);
                    q.hideField(this.form.Pieces);
                    q.hideField(this.form.CategoryId); 

                    if (this.form.ItemTypeId.value == 0)
                        this.form.ItemTypeId.value = 104;

                    if (Q.isEmptyOrNull(this.form.CategoryId.value))
                        this.form.CategoryId.value = "0";

                    if (Q.isEmptyOrNull(this.form.SubCategoryId.value))
                        this.form.SubCategoryId.value = "0";
                }

                // **** Stone Fields **** //
                if (this.form.ProductTypeId.value == "11" || this.form.ProductTypeId.value == "12" || this.form.ProductTypeId.value == "13") {

                    q.showAndSetRequiredField(this.form.QualityId);
                    q.showAndSetRequiredField(this.form.SieveId);
                    q.showAndSetRequiredField(this.form.StoneColorId);
                    q.showAndSetRequiredField(this.form.StoneSizeId);
                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.MetalId);
                    q.hideField(this.form.Purity);
                    q.hideField(this.form.PureWeight)
                    q.hideField(this.form.Purity);
                    this.form.CalcOnId.value = "5";
                    this.form.CalcUnitId.value = "8" 

                    if (this.form.ItemTypeId.value == 0)
                        this.form.ItemTypeId.value = 105;

                    switch (parseInt(this.form.CategoryId.value)) {
                        case 1:
                        case 3:
                        case 4:
                            q.hideField(this.form.StoneCutId);
                            q.hideField(this.form.StonePolishId);
                            q.hideField(this.form.StoneSymmetryId);
                            q.hideField(this.form.StoneFluorescenceId);
                            q.hideField(this.form.StoneCuletId);
                            q.hideField(this.form.StoneGirdleId);
                            q.hideField(this.form.StoneTable);
                            q.hideField(this.form.StoneDepth); 
                            //q.hideEditorCategory(this.form.StoneCuletId);
                            break;
                        case 2:
                            q.showAndSetRequiredField(this.form.StoneCutId);
                            q.showAndSetRequiredField(this.form.StonePolishId);
                            q.showAndSetRequiredField(this.form.StoneSymmetryId);
                            q.showAndSetRequiredField(this.form.StoneFluorescenceId);
                            q.showAndSetRequiredField(this.form.StoneCuletId);
                            q.showAndSetRequiredField(this.form.StoneGirdleId);
                            q.showAndSetRequiredField(this.form.StoneTable);
                            q.showAndSetRequiredField(this.form.StoneDepth); 
                            q.showAndSetRequiredField(this.form.Pieces);
                            q.showAndSetRequiredField(this.form.Weight); 

                            break;
                    }
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CategoryId) : q.showAndSetRequiredField(this.form.CategoryId);
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ShapeId) : q.showAndSetRequiredField(this.form.ShapeId);
                }
            }
            else {
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CategoryId) : q.showAndSetRequiredField(this.form.CategoryId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.BrandId) : q.showAndSetRequiredField(this.form.BrandId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CollectionId) : q.showAndSetRequiredField(this.form.CollectionId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SuperTypeId) : q.showAndSetRequiredField(this.form.SuperTypeId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductSizeId) : q.showAndSetRequiredField(this.form.ProductSizeId);
                //this.entity.ProductId > 0 ? this.form.HasBom.value == true ? q.showAndDisableField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);

                this.form.HasBom.value == true ? q.showFieldAndCategory(this.form.BOMDetails) : q.showFieldAndCategory(this.form.BOMDetails, false);
                this.form.HasBom.value == true ? q.hideField(this.form.Purity) : parseInt(this.form.KaratId.value) > 0 ? q.showAndSetRequiredField(this.form.Purity) : q.showAndDisableField(this.form.Purity);
                this.form.HasBom.value == true ? q.hideField(this.form.PureWeight) : q.showAndDisableField(this.form.PureWeight);
                //this.form.HasBom.value == true ? q.hideField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);
                this.form.HasBom.value == true ? q.showAndDisableField(this.form.Weight) : q.showAndEnableField(this.form.Weight);
                //this.form.HasBom.value == true ? q.hideEditorTab(this.form.BOMDetails, false) : q.hideEditorTab(this.form.BOMDetails);
                this.form.HasBom.value == true ? this.form.CalcOnId.value = "3" : this.form.CalcOnId.value = "4";
                this.form.HasBom.value == true ? this.form.CalcUnitId.value = "6" : this.form.CalcUnitId.value = "7";
                this.form.HasBom.value == true ? q.hideField(this.form.MetalId) : this.entity.ProductId > 0 ? q.showAndDisableField(this.form.MetalId) : q.showAndSetRequiredField(this.form.MetalId);
                this.form.HasBom.value == true ? q.hideField(this.form.KaratId) : parseInt(this.form.MetalId.value) > 0 ? q.showAndSetRequiredField(this.form.KaratId) : q.showAndDisableField(this.form.KaratId);
              

                if (!this.form.HasBom.value) {
                    this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                    q.HideCategoryLable(this.element)
                }
                q.showAndDisableField(this.form.Line_No);
                q.hideEditorTab(this.form.BOMDetails, false);
                q.hideEditorTab(this.form.ImageName, false); 
                q.showAndDisableField(this.form.NetWeight);
                q.showAndDisableField(this.form.DiamondPieces);
                q.showAndDisableField(this.form.DiamondWeight);
                q.showAndDisableField(this.form.StonePieces);
                q.showAndDisableField(this.form.StoneWeight);
                q.showAndDisableField(this.form.OtherWeight);
                q.showAndDisableField(this.form.OtherPieces); 
                q.hideField(this.form.MetalColorId);
                q.hideField(this.form.ShapeId);
                q.hideField(this.form.QualityId);
                q.hideField(this.form.StoneColorId);
                q.hideField(this.form.StoneSizeId);
                q.hideField(this.form.SieveId);
                q.hideField(this.form.StoneCutId);
                q.hideField(this.form.StonePolishId);
                q.hideField(this.form.StoneSymmetryId);
                q.hideField(this.form.StoneFluorescenceId);
                q.hideField(this.form.StoneCuletId);
                q.hideField(this.form.StoneGirdleId);
                q.hideField(this.form.StoneTable);
                q.hideField(this.form.StoneDepth); 
            }

            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductCode) : q.showAndSetRequiredField(this.form.ProductCode);
            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductName) : q.showAndSetRequiredField(this.form.ProductName);
            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductTypeId) : q.showAndSetRequiredField(this.form.ProductTypeId);
            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CalcOnId) : q.showAndSetRequiredField(this.form.CalcOnId);
            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CalcUnitId) : q.showAndSetRequiredField(this.form.CalcUnitId);


        }

        // #endregion
         

        protected validateBeforeSave() {
            var IsValid = true;
            this.form.AttributeId.value = "0";
           
            if (this.form.ItemTypeId.value == 101) {
                OMS.CommonAttributesService.GetProductATB({
                    ProductTypeId: Q.parseInteger(this.form.ProductTypeId.value),
                    ItemTypeId: this.form.ItemTypeId.value,
                    CategoryId: Q.parseInteger(this.form.CategoryId.value),
                    SubCategoryId: Q.parseInteger(this.form.SubCategoryId.value),
                    BrandId: Q.parseInteger(this.form.BrandId.value),
                    CollectionId: Q.parseInteger(this.form.CollectionId.value),
                    SuperTypeId: Q.parseInteger(this.form.SuperTypeId.value),
                    ProductSizeId: Q.parseInteger(this.form.ProductSizeId.value),
                    KaratId: Q.parseInteger(this.form.KaratId.value)
                },
                    response => {
                        this.form.AttributeId.value = response.AttributeId.toString(),
                            this.form.Attribute.value = response.AttributeCode
                    },
                    { async: false }
                );
            }

            if (this.form.ItemTypeId.value == 104) {
                OMS.CommonAttributesService.GetProductATB({
                    ProductTypeId: Q.parseInteger(this.form.ProductTypeId.value),
                    ItemTypeId: this.form.ItemTypeId.value,
                    CategoryId: Q.parseInteger(this.form.CategoryId.value),
                    SubCategoryId: Q.parseInteger(this.form.SubCategoryId.value),
                    MetalColorId: Q.parseInteger(this.form.MetalColorId.value),
                    KaratId: Q.parseInteger(this.form.KaratId.value)
                },
                    response => {
                        this.form.AttributeId.value = response.AttributeId.toString(),
                            this.form.Attribute.value = response.AttributeCode
                    },
                    { async: false }
                );
            }

            if (this.form.ItemTypeId.value == 105) {
                OMS.CommonAttributesService.GetProductATB({
                    ProductTypeId: Q.parseInteger(this.form.ProductTypeId.value),
                    ItemTypeId: this.form.ItemTypeId.value,
                    CategoryId: Q.parseInteger(this.form.CategoryId.value),
                    SubCategoryId: Q.parseInteger(this.form.SubCategoryId.value),
                    ShapeId: Q.parseInteger(this.form.ShapeId.value),
                    QualityId: Q.parseInteger(this.form.QualityId.value),
                    StoneSizeId: Q.parseInteger(this.form.StoneSizeId.value),
                    SieveId: Q.parseInteger(this.form.SieveId.value),
                    GroupSieveId: Q.parseInteger(this.form.GroupSieveId.value),
                    StoneColorId: Q.parseInteger(this.form.StoneColorId.value),
                    StoneCutId: Q.parseInteger(this.form.StoneCutId.value),
                    StonePolishId: Q.parseInteger(this.form.StonePolishId.value),
                    StoneSymmetryId: Q.parseInteger(this.form.StoneSymmetryId.value),
                    StoneFluorescenceId: Q.parseInteger(this.form.StoneFluorescenceId.value),
                    StoneCuletId: Q.parseInteger(this.form.StoneCuletId.value),
                    StoneGirdleId: Q.parseInteger(this.form.StoneGirdleId.value),
                    StoneTable: this.form.StoneTable.value,
                    StoneDepth: this.form.StoneDepth.value
                },
                    response => {
                        this.form.AttributeId.value = response.AttributeId.toString(),
                            this.form.Attribute.value = response.AttributeCode
                    },
                    { async: false }
                );
            }

            if (this.form.ItemTypeId.value == 101) {

                if (this.form.HasBom.value) {
                    let items = this.form.BOMDetails.getItems();
                    let count = 0;
                    if (items.length > 0) {

                        items.forEach(function (x) {
                            if (x.ItemTypeId == 104)
                                count++
                        });

                        if (count == 0) {
                            q.Warning("Can not Save!", "Metal details not defined", false);
                            IsValid = false;
                        }
                        else
                            IsValid = true;
                    }
                    else {
                        q.Warning("Can not Save!", "Components or BOM is not defined", false);
                        IsValid = false;

                    }
                }

                
                if (Q.isEmptyOrNull(this.form.Line_No.value)) {
                    Purchase.PurchaseMasterService.GetLineNo({}, response => this.form.Line_No.value = response.Line_No.toString(), {
                        async: false
                    });
                }


            } 

            if (this.form.Weight.value == 0) {
                q.Warning("Can not Save!", "Weight is undefined or 0", false);
                IsValid = false;
            }
            else {
                IsValid = true;
            }

            return IsValid;

        }
        // #endregion

    }
}